export class Doc {
    _id:string;
    ficheurl: string;
    created: Date;
    updated: Date;
    titre:string;
    commentaire:string;
    profils:any
}
